/**
 * Contains variables that could be user-modified on Settings page
 */
import _ from "lodash";
import { auvikEggplant, auvikLavender, auvikPurple, lightGray, white } from "./colors";
export const defaultUserTheme2023 = {
    darkThemeAction: auvikLavender[800],
    darkThemeBrandPrimary: auvikPurple[500],
    darkThemeBrandSecondary: auvikLavender[500],
    darkThemeMapBackground: lightGray[200],
    darkThemeSidebarBackground: "#302F32",
    darkThemeSidebarText: lightGray[200],
    logoUrl: "/assets/images/Auvik-Logo-Full-Rev-Dk-RGB.png",
    themeAction: auvikLavender[800],
    themeBrandPrimary: auvikPurple[500],
    themeBrandSecondary: auvikEggplant[500],
    themeMapBackground: lightGray[200],
    themeName: "lightTheme2023",
    themeSidebarBackground: auvikEggplant[500],
    themeSidebarText: white,
};
export function getUserTheme(themeSettings = {}) {
    const defaultThemeSettings = {
        darkThemeAction: themeSettings.darkColorAction,
        darkThemeBrandPrimary: themeSettings.darkColorBrandPrimary,
        darkThemeBrandSecondary: themeSettings.darkColorBrandSecondary,
        darkThemeMapBackground: themeSettings.darkColorMapBackground,
        darkThemeSidebarBackground: themeSettings.darkColorSidebarBackground,
        darkThemeSidebarText: themeSettings.darkColorSidebarText,
        logoUrl: themeSettings.logo,
        themeAction: themeSettings.colorAction,
        themeBrandPrimary: themeSettings.colorBrandPrimary,
        themeBrandSecondary: themeSettings.colorBrandSecondary,
        themeMapBackground: themeSettings.colorMapBackground,
        themeName: themeSettings.themeName,
        themeSidebarBackground: themeSettings.colorSidebarBackground,
        themeSidebarText: themeSettings.colorSidebarText,
    };
    return _.merge(defaultUserTheme2023, defaultThemeSettings);
}
